import { axiosHyperwolfDevClient } from "axiosClient";

export async function fetchDriversRegionsAPI(data) { 
    return await axiosHyperwolfDevClient.get(data === 'driver'? `/api/v1/regions/get`:'/api/v1/regions/fetch/listing',
    )
  }